import React, { useMemo } from 'react';
import { useMutation } from 'react-query';
import { FormikTextField } from '../../../common/formik-material-ui';
import { Paper } from '@mui/material';
import { Formik } from 'formik';
import { ModalWithStyles } from './ModalWithStyles';
import { useSnackbarWithStyles } from '../notifications/SnackbarProviderWithStyles';
import { endpointEnum } from '../../../services/rest/makeAPIRequest';
import * as Yup from 'yup';
import { getApiMutation } from '../../../services/rest/getApiMutation';
import { useRecoilStateLoadable } from 'recoil';
import { IUserAtom, user } from '../../../recoil/atoms/user';
import { Logger } from '../../../common/Logger';

export const MakePhoneCallModal = (props: {
  show: boolean;
  handleClose: (value: boolean) => void;
  fromPhoneNumber: string | undefined;
  businessId: number;
}) => {
  const makePhoneCallSchema = useMemo(
    () =>
      Yup.object({
        toPhoneNumber: Yup.string()
          .required('Required')
          .isValidNumber(
            'Non E164 number entered, please reformat and try again.'
          ),
      }),
    []
  );

  const toPhoneNumber = localStorage.getItem('toPhoneNumber') || '+';
  const [userAtom, setUserAtom] = useRecoilStateLoadable(user);
  const mutation = useMutation(
    getApiMutation(userAtom.contents as IUserAtom, setUserAtom)
  );
  const { enqueueSnackbarWithStyles } = useSnackbarWithStyles();
  return (
    <Paper elevation={0} square={true}>
      <Formik
        initialValues={{
          toPhoneNumber: toPhoneNumber,
        }}
        onSubmit={async (values, actions) => {
          const data = {
            businessId: props.businessId,
            fromNumber: props.fromPhoneNumber,
            toNumber: values.toPhoneNumber,
          };

          try {
            localStorage.setItem('toPhoneNumber', values.toPhoneNumber);
            const response = await mutation.mutateAsync({
              method: 'post',
              domain: process.env.VITE_APP_CDK_DOMAIN,
              endpoint: endpointEnum.MAKE_PHONE_CALL,
              payload: data,
            });
            Logger.info(response);
          } catch (err) {
            Logger.info(err);
          }

          actions.resetForm({});
          enqueueSnackbarWithStyles({
            message: `Calling number`,
            alertProps: { severity: 'success' },
          });
          props.handleClose(false);
        }}
        validationSchema={makePhoneCallSchema}
        enableReinitialize={true}
      >
        {(formik) => {
          return (
            <ModalWithStyles
              onSubmit={formik.handleSubmit}
              title={`Call from number - ${props.fromPhoneNumber}`}
              aria-labelledby="example-modal-sizes-title-lg"
              show={props.show}
              onHide={() => {
                props.handleClose(false);
                formik.resetForm({});
              }}
              submitLabel="Call"
              isSubmitting={formik.isSubmitting}
              isLoading={formik.isSubmitting}
              disableSubmit={!formik.isValid}
              size="sm"
            >
              <div className="row">
                <FormikTextField
                  name="toPhoneNumber"
                  formik={formik}
                  label="Number to call"
                  size="small"
                  inputProps={{ maxLength: 45 }}
                  required
                  fullWidth
                  helperText="Number must be in E164 format"
                  variant="outlined"
                />
              </div>
              <br />
              <br />
            </ModalWithStyles>
          );
        }}
      </Formik>
    </Paper>
  );
};
